import { useValidationsField } from '@insurance/hooks'

import { InsuranceRcaMainStep } from '../InsuranceRcaMainStep'

export const MainStep = () => {
  const { certificateNumberGreenCard } = useValidationsField()

  return (
    <InsuranceRcaMainStep certificateValidator={certificateNumberGreenCard} />
  )
}
